<template>
  <div class="bqv2-index">
    <div class="loading">
      <bq-header />
      <div class="content-wrapper">
        <div class="search-wrapper" data-aos="fade-in">
          <!-- <input type="text" placeholder="输入搜素内容" class="search-wrapper-input"> -->
          <div style="margin-top: 0px">
            <el-input
              placeholder="请输入内容"
              v-model="input2"
              :class="input2 ? 'active2' : ''"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="search"
              ></el-button>
              <!-- <template slot="append">.com</template> -->
            </el-input>
            <div style="margin-top: 8px; padding-left: 18px" class="search-tag">
              人气搜索：
              <span
                @click="select(item)"
                v-for="(item, index) in shortSearch"
                :key="'0' + index"
                class="pointer"
              >
                {{ item }}
              </span>
            </div>
          </div>
        </div>
        <div
          class="recommand-wrapper wrapper clearfix recommand-wrapper-wrapper"
          style="padding-top: 108px; width: 1200px; box-sizing: border-box"
        >
          <div class="" data-wow-delay="0.08s" data-aos="fade-right">
            <div class="recommand-wrapper-txt2">rementuijian</div>

            <div class="recommand-wrapper-txt">热门推荐</div>
            <div class="recommand-wrapper-like">猜你喜欢></div>
          </div>
          <!--  data-aos-offset="200" -->
          <div class="recommand-wrapper-swiper" data-aos="fade-left">
            <!--  indicator-position="outside" -->
            <button
              type="button"
              class="carousel__arrow carousel__arrow__left"
              @click="preV"
              :class="!isShow1.pre ? 'disNo' : ''"
            >
              <i class="el-icon-arrow-left icon-arrow"></i>
            </button>
            <button
              type="button"
              class="carousel__arrow carousel__arrow__right"
              @click="nextV"
              :class="!isShow1.next ? 'disNo' : ''"
            >
              <i class="el-icon-arrow-right icon-arrow"></i>
            </button>
            <!-- <el-carousel
            :height="'240px'"
            :autoplay="false"
            :loop="false"
            indicator-position="none"
            ref="carousel1"
            @change="change1"
          >
            <el-carousel-item v-for="(item) in 4" :key="item">
              <img
                :src="item.imgSrc"
                alt=""
                v-for="(item, index) in listTop"
                :key="index+'100'"
                class="carousel-img"
              />
            </el-carousel-item>
          </el-carousel> -->
            <swiper class="swipernn" :options="swiperTop" ref="swiperTop">
              <swiper-slide
                class="slide-1"
                v-for="(item, index) in listTop"
                :key="'01' + index"
              >
                <div
                  class="swiper-slide-item"
                  style="height: 100%; width: 300px"
                >
                  <!-- {{item}} -->
                  <div class="img-wrapper img-animate swiper-img">
                    <img
                      :src="item.imgSrc"
                      alt=""
                      style="width: 100%; height: 100%"
                      class="pointer"
                    />
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <!-- 主体 -->
        <div class="contentwrapper" style="margin-top: 38px">
          <div class="contentwrapper1">
            <div
              class="contentwrapper-item"
              :class="index % 2 == 0 ? 'odd-item' : 'even-item'"
              style="height: 875px"
              v-for="(item, index) in list1"
              :key="'23' + index"
            >
              <div class="contentwrapper-item2">
                <div
                  class="wrapper"
                  v-if="index % 2 == 0"
                  style="padding-top: 1px"
                  data-aos="fade-down"
                >
                  <div
                    class="item-txt clearfix"
                    data-wow-delay="0.08s"
                    data-aos-offset="200"
                  >
                    <div
                      style="z-index: 3; position: relative; cursor: pointer"
                      @click.stop="search(item.nameKEY)"
                    >
                       {{ item.typeTitle }}
                    </div>
                    <img :src="titlelogo" alt="" style="z-index: 2" />
                  </div>
                  <div
                    class="look-more right"
                    @click.stop="search(item.nameKEY)"
                  >
                    查看更多
                  </div>
                  <div class="item-img clearfix">
                    <div
                      class="item-img-left"
                      @click="toDetail(item.imgList[0])"
                      v-if="item.imgList[0]"
                    >
                      <div
                        class="img-wrapper img-animate"
                        data-wow-delay="0.08s"
                        data-aos-offset="200"
                        data-aos="fade-right"
                      >
                        <img
                          :src="item.imgList[0].imgSrc1"
                          alt="1"
                          class="pointer"
                          @click.stop="toDetail(item.imgList[0])"
                        />
                        <div class="mask"></div>
                      </div>

                      <div class="item-txt-lr line1">
                        {{ item.imgList[0].title }}
                      </div>
                    </div>
                    <div
                      class="item-img-right flex-bt-y"
                      style="width: 641px; height: 100%"
                    >
                      <div
                        class="img-wrapper img-animate"
                        data-wow-delay="0.08s"
                        data-aos-offset="200"
                        data-aos="fade-down"
                        style="height: 300px"
                        v-if="item.imgList[1]"
                      >
                        <img
                          :src="item.imgList[1] ? item.imgList[1].imgSrc2 : ''"
                          alt="2"
                          style="height: 300px"
                          @click.stop="toDetail(item.imgList[1])"
                          class="pointer"
                        />
                        <div class="item-txt-lr line1">
                          {{ item.imgList[1].title }}
                        </div>
                        <div class="mask"></div>
                      </div>

                      <div class="flex-bt">
                        <div
                          class="img-wrapper img-animate"
                          data-wow-delay="0.08s"
                          data-aos-offset="50"
                          data-aos="fade-up"
                          v-if="item.imgList[2]"
                        >
                          <img
                            :src="
                              item.imgList[2] ? item.imgList[2].imgSrc3 : ''
                            "
                            alt="3"
                            style="width: 302px; height: 362px"
                            @click.stop="toDetail(item.imgList[2])"
                            class="pointer"
                          />
                          <div class="item-txt-lr line1">
                            {{ item.imgList[2].title }}
                          </div>
                          <div class="mask"></div>
                        </div>

                        <div
                          class="img-wrapper img-animate"
                          data-wow-delay="0.08s"
                          data-aos-offset="50"
                          data-aos="fade-left"
                          v-if="item.imgList[3]"
                        >
                          <img
                            :src="
                              item.imgList[3] ? item.imgList[3].imgSrc3 : ''
                            "
                            alt="3"
                            style="width: 302px; height: 362px"
                            @click.stop="toDetail(item.imgList[3])"
                            class="pointer"
                          />
                          <div class="item-txt-lr line1">
                            {{ item.imgList[3].title }}
                          </div>
                          <div class="mask"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="wrapper"
                  style="padding-top: 1px"
                  v-if="index % 2 == 1"
                  data-aos="fade-down"
                >
                  <div class="item-txt clearfix">
                    <div
                      style="z-index: 3; position: relative; margin-right: 20px"
                    >
                       {{ item.typeTitle }}
                    </div>
                    <img
                      :src="titlelogo"
                      alt=""
                      style="z-index: 2; right: 6px"
                    />
                  </div>
                  <div
                    class="look-more left"
                    @click.stop="search(item.nameKEY)"
                  >
                    查看更多
                  </div>
                  <div class="item-img clearfix">
                    <div
                      class="item-img-left flex-bt-y"
                      style="width: 641px; height: 100%"
                    >
                      <div
                        class="img-wrapper img-animate"
                        data-aos="fade-down"
                        style="height: 300px"
                        v-if="item.imgList[0]"
                      >
                        <img
                          :src="item.imgList[0].imgSrc2"
                          alt="1"
                          style="width: 641px; height: 300px"
                          @click.stop="toDetail(item.imgList[0])"
                          class="pointer"
                        />
                        <div class="item-txt-lr line1">
                          {{ item.imgList[0].title }}
                        </div>
                        <div class="mask"></div>
                      </div>

                      <div class="flex-bt">
                        <div
                          class="img-wrapper img-animate"
                          data-aos="fade-right"
                          v-if="item.imgList[1]"
                        >
                          <img
                            :src="
                              item.imgList[1] ? item.imgList[1].imgSrc3 : ''
                            "
                            alt="2"
                            style="width: 302px; height: 362px"
                            @click.stop="toDetail(item.imgList[1])"
                            class="pointer"
                          />
                          <div class="item-txt-lr line1">
                            {{ item.imgList[1].title }}
                          </div>
                          <div class="mask"></div>
                        </div>
                        <div
                          class="img-wrapper img-animate"
                          data-aos="fade-up"
                          v-if="item.imgList[2]"
                        >
                          <img
                            :src="
                              item.imgList[2] ? item.imgList[2].imgSrc3 : ''
                            "
                            alt="2"
                            style="width: 302px; height: 362px"
                            @click.stop="toDetail(item.imgList[2])"
                            class="pointer"
                          />
                          <div class="item-txt-lr line1">
                            {{ item.imgList[2].title }}
                          </div>
                          <div class="mask"></div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="item-img-right"
                      @click.stop="toDetail(item.imgList[3])"
                      v-if="item.imgList[3]"
                    >
                      <div class="img-wrapper img-animate" data-aos="fade-left">
                        <img
                          :src="item.imgList[3] ? item.imgList[3].imgSrc1 : ''"
                          alt="2"
                          class="pointer"
                        />
                        <!-- <div class="item-txt-lr line1">{{ item.imgList[3].title }}</div> -->
                        <div class="mask"></div>
                      </div>

                      <div class="item-txt-lr">{{ item.imgList[3].title }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--主体1  -->
            <!-- <div class="contentwrapper-item odd-item" style="height: 875px">
            <div class="contentwrapper-item2">
              <div class="wrapper">
                <div class="item-txt clearfix">
                  <div style="z-index: 3; position: relative">
                    MEISHU / 美术
                  </div>
                  <img :src="titlelogo" alt="" style="z-index: 2" />
                </div>
                <div class="item-img clearfix">
                  <div class="item-img-left">
                    <img :src="defaultImg" alt="1" class="img-animate" />
                    <div class="item-txt-lr">美术作品名称meishuzuopinmc</div>
                  </div>
                  <div
                    class="item-img-right flex-bt-y"
                    style="width: 641px; height: 100%"
                  >
                    <img :src="defaultImg" alt="2" style="height: 300px" />
                    <div class="flex-bt flex-bt">
                      <img
                        :src="defaultImg"
                        alt="3"
                        style="width: 302px; height: 362px"
                      />
                      <img
                        :src="defaultImg"
                        alt="3"
                        style="width: 302px; height: 362px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

            <!--主体2  -->
            <!-- <div class="contentwrapper-item even-item" style="height: 875px">
            <div class="contentwrapper-item2">
              <div class="wrapper">
                <div class="item-txt clearfix">
                  <div
                    style="z-index: 3; position: relative; margin-right: 20px"
                  >
                    MEISHU / 美术
                  </div>
                  <img :src="titlelogo" alt="" style="z-index: 2; right: 6px" />
                </div>
                <div class="item-img clearfix">
                  <div
                    class="item-img-left flex-bt-y"
                    style="width: 641px; height: 100%"
                  >
                    <img
                      :src="defaultImg"
                      alt="1"
                      style="width: 640px; height: 300px"
                    />
                    <div class="flex-bt flex-bt">
                      <img
                        :src="defaultImg"
                        alt="3"
                        style="width: 302px; height: 362px"
                      />
                      <img
                        :src="defaultImg"
                        alt="3"
                        style="width: 302px; height: 362px"
                      />
                    </div>
                  </div>
                  <div class="item-img-right">
                    <img :src="defaultImg" alt="3" />
                    <div class="item-txt-lr">美术作品名称meishuzuopinmc</div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
            <!--主体3  -->
            <!-- <div class="contentwrapper-item odd-item" style="height: 876px">
            <div class="contentwrapper-item2">
              <div class="wrapper">
                <div class="item-txt clearfix">
                  <div style="z-index: 3; position: relative">
                    YISHUJIA /艺术家
                  </div>
                  <img :src="titlelogo" alt="" style="z-index: 2" />
                </div>
                <div class="item-img clearfix">
                  <div class="item-img-left">
                    <img :src="defaultImg" alt="1" />
                    <div class="item-txt-lr">美术作品名称meishuzuopinmc</div>
                  </div>
                  <div class="item-img-right" style="width: 643px">
                    <img :src="defaultImg" alt="2" />
                    <img :src="defaultImg" alt="3" />
                  </div>
                </div>
              </div>
            </div>
          </div> -->
            <!--主体4  -->
            <div class="contentwrapper-item bgc">
              <div
                class="contentwrapper-item2"
                :style="'backgroundImage: url(' + bg + ');'"
              ></div>
              <!-- <img :src="bgTitle" alt="" class="bg-title" /> -->
            </div>
            <!--主体4  -->
            <!-- <div
            class="contentwrapper-item even-item change"
            style="
              margin-top: -333px;
              height: 865px;
              background: #f2efec;
              border-radius: 320px 0px 0px 0px;
            "
          >
            <div class="contentwrapper-item2">
              <div class="wrapper">
                <div class="item-txt clearfix">
                  <div
                    style="z-index: 3; position: relative; margin-right: 20px"
                  >
                    MEISHU / 美术
                  </div>
                  <img :src="titlelogo" alt="" style="z-index: 2; right: 6px" />
                </div>
                <div class="item-img clearfix">
                  <div class="item-img-left" style="width: 568px">
                    <img :src="defaultImg" alt="1" />
                    <img :src="defaultImg" alt="2" />
                  </div>
                  <div class="item-img-right">
                    <img :src="defaultImg" alt="3" />
                    <div class="item-txt-lr">美术作品名称meishuzuopinmc</div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

            <div
              class="contentwrapper-item even-item change"
              style="
                margin-top: -273px;
                height: 865px;
                background: #f2efec;
                border-radius: 240px 0px 0px 0px;
              "
              v-for="(item, index) in list2"
              :key="'33' + index"
            >
              <div class="contentwrapper-item2">
                <div
                  class="wrapper"
                  data-aos="fade-down"
                  style="padding-top: 1px"
                >
                  <div class="item-txt clearfix">
                    <div
                      style="
                        cursor: pointer;
                        z-index: 3;
                        position: relative;
                        margin-right: 20px;
                      "
                      @click.stop="search(item.nameKEY)"
                    >
                      {{ item.typeTitle }}
                    </div>
                    <img
                      :src="titlelogo"
                      alt=""
                      style="z-index: 2; right: 6px"
                    />
                  </div>
                  <div
                    class="look-more left"
                    @click.stop="search(item.nameKEY)"
                  >
                    查看更多
                  </div>
                  <div class="item-img clearfix">
                    <div class="item-img-left flex-bt-y" style="height: 100%">
                      <div
                        class="img-wrapper img-animate"
                        style="height: 300px"
                        v-if="item.imgList[0]"
                      >
                        <img
                          :src="item.imgList[0].imgSrc2"
                          alt="1"
                          style="width: 641px; height: 300px"
                          @click.stop="toDetail(item.imgList[0])"
                          class="pointer"
                          data-aos="fade-down"
                        />
                        <div class="item-txt-lr line1">
                          {{ item.imgList[0].title }}
                        </div>
                        <div class="mask"></div>
                      </div>
                      <div class="flex-bt">
                        <div
                          class="img-wrapper img-animate"
                          v-if="item.imgList[1]"
                        >
                          <img
                            :src="
                              item.imgList[1] ? item.imgList[1].imgSrc3 : ''
                            "
                            alt="2"
                            style="width: 302px; height: 362px"
                            @click.stop="toDetail(item.imgList[1])"
                            class="pointer"
                            data-aos="fade-right"
                          />
                          <div class="item-txt-lr line1">
                            {{ item.imgList[1].title }}
                          </div>
                          <div class="mask"></div>
                        </div>
                        <div
                          class="img-wrapper img-animate"
                          v-if="item.imgList[2]"
                        >
                          <img
                            :src="
                              item.imgList[2] ? item.imgList[2].imgSrc3 : ''
                            "
                            alt="2"
                            style="width: 302px; height: 362px"
                            @click.stop="toDetail(item.imgList[2])"
                            class="pointer"
                            data-aos="fade-up"
                          />
                          <div class="item-txt-lr line1">
                            {{ item.imgList[2].title }}
                          </div>
                          <div class="mask"></div>
                        </div>
                      </div>
                    </div>

                    <div class="item-img-right" v-if="item.imgList[3]">
                      <div class="img-wrapper img-animate">
                        <img
                          :src="item.imgList[3] ? item.imgList[3].imgSrc1 : ''"
                          alt="2"
                          class="pointer"
                          data-aos="fade-left"
                          @click.stop="toDetail(item.imgList[3])"
                        />
                        <!-- <div class="item-txt-lr line1">{{ item.imgList[3].title }}</div> -->
                        <div class="mask"></div>
                      </div>
                      <div class="item-txt-lr">{{ item.imgList[3].title }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style="background-color: #f2efec; width: 100%; height: 500px"
          class="recommand-wrapper-wrapper"
        >
          <div
            class="recommand-wrapper clearfix"
            style="
              border-radius: 240px 0px 0px 0px;
              background-color: #ffffff;
              box-sizing: border-box;
              padding-top: 114px;
              height: 500px;
            "
          >
		  
            <div class="wrapper">
              <div class="" data-wow-delay="0.08s" data-aos="fade-right">
                <div class="recommand-wrapper-txt2">rementuijian</div>

                <div class="recommand-wrapper-txt">热门推荐</div>
                <div class="recommand-wrapper-like">猜你喜欢></div>
              </div>
              <div
                class="recommand-wrapper-swiper"
                data-wow-delay="0.08s"
                data-aos="fade-left"
              >
                <button
                  type="button"
                  class="carousel__arrow carousel__arrow__left"
                  @click="preV2"
                  :class="!isShow2.pre ? 'disNo' : ''"
                >
                  <i class="el-icon-arrow-left icon-arrow"></i>
                </button>
                <button
                  type="button"
                  class="carousel__arrow carousel__arrow__right"
                  @click="nextV2"
                  :class="!isShow2.next ? 'disNo' : ''"
                >
                  <i class="el-icon-arrow-right icon-arrow"></i>
                </button>
                <!-- <el-carousel
                  :height="'240px'"
                  :autoplay="false"
                  :loop="false"
                  indicator-position="none"
                  ref="carousel1"
                  @change="change1"
                >
                  <el-carousel-item v-for="item in 4" :key="item">
                    <img
                      :src="imgsrc"
                      alt=""
                      v-for="(imgsrc, index) in imgList"
                      :key="index"
                      class="carousel-img"
                    />
                  </el-carousel-item>
                </el-carousel> -->
                <swiper class="swipernn" :options="swiperBm" ref="swiperBm">
                  <swiper-slide
                    class="slide-1"
                    v-for="(item, index) in listBm"
                    :key="'01' + index"
                  >
                    <div
                      class="swiper-slide-item"
                      style="height: 100%; width: 300px"
                    >
                      <!-- {{item}} -->
                      <div class="img-wrapper img-animate swiper-img">
                        <img
                          :src="item.imgSrc"
                          alt=""
                          style="width: 100%; height: 100%"
                          class="pointer"
                        />
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
              <!--  indicator-position="outside" -->
            </div>
          </div>
        </div>
      </div>
      <bq-footer></bq-footer>
    </div>
  </div>
</template>

<script>
// 1270
// 865 + 876 + 876 +866 + 865 + 500
//
import "@/router/index.css";
import "@/router/other.css";
import titlelogo from "@/assets/V2/title_logo.png";
import bgTitle from "@/assets/V2/V2-bg-title.png";
import bg from "@/assets/V2/V2-bg2.png";
import bqHeader from "@/view/V2/components/header.vue";
// import bqFooter from "@/view/V2/components/footer.vue";
import bqFooter from "@/components/tail";
import { swiper, swiperSlide } from "vue-awesome-swiper";
// import swiper from "vue-awesome-swiper/src/swiper.vue";
// import swiperSlide from "vue-awesome-swiper/src/slide.vue";
import "swiper/dist/css/swiper.css";
import "wowjs/css/libs/animate.css";
import WOW from "wowjs";
import "aos/dist/aos.css";
import AOS from "aos/dist/aos.js";
const showSwiper = 3;
export default {
  components: {
    bqHeader,
    bqFooter,
    swiper,
    swiperSlide,
  },
  computed: {
    activeIndex() {
      console.log("activeIndex");
      return this.swiperTopTemp.activeIndex
        ? this.swiperTopTemp.activeIndex
        : this.temp;
    },
    listTopLength() {
      return this.listTop.length;
    },
    listBmLength() {
      return this.listBm.length;
    },
  },
  data() {
    return {
      loading: false,
      bgTitle: bgTitle,
      bg: bg,
      num: 7,
      swiperTop: {},
      swiperBm: {},
      swiperIndex1: 0,
      // 缓存ref
      swiperTopTemp: {},
      temp: -1,
      isShow1: {
        pre: false,
        next: false,
      },
      isShow2: {
        pre: false,
        next: false,
      },
      shortSearch: ["美术", "摄影"],
      listTop: [],
      listBm: [],
      list: [],
      // 固定图片上面的
      list1: [],
      // 固定图片下面的
      list2: [],
      titlelogo: titlelogo,
      curSwpierIndex1: 0,
      curSwpierIndex2: 0,
      input2: "",
      imgList: [
        {
          imgSrc:
            "https://img2.baidu.com/it/u=3635204433,939208923&fm=253&fmt=auto&app=138&f=JPEG?w=375&h=500",
        },
        {
          imgSrc:
            "https://img2.baidu.com/it/u=3635204433,939208923&fm=253&fmt=auto&app=138&f=JPEG?w=375&h=500",
        },
        {
          imgSrc:
            "https://img2.baidu.com/it/u=3635204433,939208923&fm=253&fmt=auto&app=138&f=JPEG?w=375&h=500",
        },
      ],
      defaultImg:
        "https://img2.baidu.com/it/u=3635204433,939208923&fm=253&fmt=auto&app=138&f=JPEG?w=375&h=500",
    };
  },
  watch: {
    activeIndex(newVal, oldVal) {
      console.log(newVal);
    },
    list2() {
      this.$nextTick(() => {
        // 在dom渲染完后,再执行动画
        // this.$wow.init()
        // new WOW({
        //   boxClass: "wow", // 需要执行动画的元素的 class
        //   animateClass: "animated", //animation.css 动画的 class
        //   offset: 0, // 距离可视区域多少开始执行动画
        //   mobile: true, // 是否在移动设备上执行动画
        //   // live: true, // 异步加载的内容是否有效
        // }).init();
        console.log("123");
        // new this.$wow.WOW().init();
        AOS.init({
          offset: 10,
          duration: 600,
          easing: "ease-in-sine",
          delay: 100,
        });
        // new WOW.WOW({
        //   boxClass: "wow",
        //   animateClass: "animated",
        //   offset: 0,
        //   mobile: true,
        //   live: true,
        // });
      });
    },
  },
  async created() {
    this.setOption1();
    this.setOption2();
    
    // 顶部背景图
    // var data = await this.$getHttp("pc/tShow/img");
    // window.localStorage.setItem("V2-bg", data.list.img);
    
    AOS.init({
      offset: 10,
      duration: 600,
      easing: "ease-in-sine",
      delay: 100,
    });

    // this.list1 = arr.slice(0, arr.length - 1);

    
    
    
    var list1 = await this.$getHttp("pc/tShow/top", {
      isPush: 1,
    });
    // 顶部推荐
    this.listTop = list1.list.map((item, index) => {
      return {
        imgSrc: this.$baseUrl + item.cimg,
        id: item.id,
        workId: item.workId
      };
    });

    // this.listTop.push(...this.imgList);
    this.isShow1.next = this.listTopLength > 3;

    var list2 = await this.$getHttp("pc/tShow/db", {
      isPushOk: 0,
    });
    // 底部推荐
    this.listBm = list2.list.map((item, index) => {
      return {
        imgSrc: this.$baseUrl + item.cimg,
        id: item.id,
        workId: item.workId
      };
    });
    // this.listBm.push(...this.imgList);

    this.isShow2.next = this.listBmLength > 3;
    // 主体内容
    // var  arr = list3.list.map((item, index) => {
    //   return {
    //     aimg: this.$baseUrl + item.aimg,
    //     bimg: this.$baseUrl + item.bimg,
    //     cimg:this.$baseUrl + item.cimg,
    //     sort: item.sort,
    //     id: item.id,
    //     title:item.workName+' '+item.workEname
    //   };
    // });
    // for (var key in list3.list) {
    //   console.log(key);
    //   console.log(list3.list[key]);
    // }
    // console.log(arr,22222)

    // aimg: "http://qs6ikt.natappfree.cc/upload/";
    // bimg: "http://qs6ikt.natappfree.cc/upload/";
    // cimg: "http://qs6ikt.natappfree.cc/upload/";
    // eNameKEY: "sdads";
    // id: "068a54f99db0420597215fbaede97480";
    // isShowKEY: "1";
    // nameKEY: "十大";
    // sort: "22";
    // sortKEY: "1";
    // title: "1111 2222";
    
    return;
    // Type(eName=sdads, name=十大, sort=1, isShow=1)
    // Type(eName=meishu, name=美术, sort=3, isShow=1)
    // console.log(list1);
    // console.log(list2);
    // console.log(list3);
  },
  async mounted() {
    // console.log(this.$refs.swiperTop.swiper, 123);
    if(this.$route.query.openid){
      window.sessionStorage.setItem("openid",this.$route.query.openid);
    }

    var list3 = await this.$getHttp("pc/tType/list", {
      num: 4,
    });
    var obj = list3.list;
    var arr = [];
    for (var key in obj) {
      var targetArr = key.substring(5, key.length - 1).split(", ");
      var temp = {};
      var imgList = [];
      targetArr.map((item) => {
        temp[item.split("=")[0] + "KEY"] = item.split("=")[1];
      });
      if (temp.eNameKEY && temp.nameKEY) {
        temp.typeTitle = temp.eNameKEY + "/" + temp.nameKEY;
      } else {
        temp.typeTitle = temp.eNameKEY ? temp.eNameKEY : temp.nameKEY;
      }

      obj[key].map((item, index) => {
        imgList.push({
          imgSrc1: this.$baseUrl + item.aimg,
          imgSrc2: this.$baseUrl + item.bimg,
          imgSrc3: this.$baseUrl + item.eimg,
          sort: item.sort,
          id: item.id,
          workId:item.workId,
          title: item.workName + " " + item.workEname,
        });
      });

      arr.push({
        imgList: imgList.length ? imgList : [],
        ...temp,
      });
    }
    console.log(arr);
    arr.map((temp) => {
      temp.imgList.sort(function (a, b) {
        return parseInt(a.sort) - parseInt(b.sort);
      });
    });

    arr.sort(function (a, b) {
      return parseInt(a.sortKEY) - parseInt(b.sortKEY);
    });
    console.log(arr);
    if (arr.length <= 1) {
      this.list1 = arr;
    } else {
      this.list1 = arr.slice(0, arr.length - 1);
      this.list2 = arr.slice(arr.length - 1, arr.length);
    }

    this.loading = true;
    console.log(this.list1);
    console.log(this.list2);
  },
  methods: {
    toDetail(item) {
      console.log(item);
      this.$router.push({
        path: "/workDetails",
        query: {
          id: item.id,workId: item.workId
        },
      });
    },
    preV(arg) {
      // this.$refs.carousel1.prev();
      const swiperTop = this.$refs.swiperTop.swiper;
      if (swiperTop.activeIndex - 0 == 1) {
        arg = swiperTop.activeIndex - 1;
        swiperTop.slideTo(arg, 300, false);
        // this.isShow1.pre = false;
      } else if (swiperTop.activeIndex - 0 > 1) {
        arg = swiperTop.activeIndex - 1;
        swiperTop.slideTo(arg, 300, false);
        // this.isShow1.pre = true;
      } else {
        // this.isShow1.pre = false;
      }
      // this.isShow1.next = true;
      // swiperTop.slideTo(this.swiperIndex1, 300, false);
    },
    preV2(arg) {
      // this.$refs.carousel1.prev();
      const swiperBm = this.$refs.swiperBm.swiper;
      if (swiperBm.activeIndex - 0 == 1) {
        arg = swiperBm.activeIndex - 1;
        swiperBm.slideTo(arg, 300, false);
        // this.isShow2.pre = false;
      } else if (swiperBm.activeIndex - 0 > 1) {
        arg = swiperBm.activeIndex - 1;
        swiperBm.slideTo(arg, 300, false);
        // this.isShow2.pre = true;
      } else {
        // this.isShow2.pre = false;
      }
      // this.isShow2.next = true;
      // swiperTop.slideTo(this.swiperIndex1, 300, false);
    },
    nextV(arg) {
      const swiperTop = this.$refs.swiperTop.swiper;
      // 可以滚动的最大范围
      var maxNum = this.listBmLength - showSwiper;
      // var maxNum = this.listTop.length - showSwiper;
      if (maxNum - swiperTop.activeIndex == 1) {
        arg = swiperTop.activeIndex + 1;
        swiperTop.slideTo(arg, 300, false);
        // this.isShow1.next = false;
      } else if (maxNum - swiperTop.activeIndex > 1) {
        arg = swiperTop.activeIndex + 1;
        swiperTop.slideTo(arg, 300, false);
        // this.isShow1.next = true;
      } else {
        // this.isShow1.next = false;
      }
      // this.isShow1.pre = true;
    },
    nextV2(arg) {
      const swiperBm = this.$refs.swiperBm.swiper;
      // 可以滚动的最大范围
      var maxNum = this.listBmLength - showSwiper;
      // var maxNum = this.listTop.length - showSwiper;
      if (maxNum - swiperBm.activeIndex == 1) {
        arg = swiperBm.activeIndex + 1;
        swiperBm.slideTo(arg, 300, false);
        // this.isShow2.next = false;
      } else if (maxNum - swiperBm.activeIndex > 1) {
        arg = swiperBm.activeIndex + 1;
        swiperBm.slideTo(arg, 300, false);
        // this.isShow2.next = true;
      } else {
        // this.isShow2.next = false;
      }
      // this.isShow2.pre = true;
    },
    //
    change1(i) {
      this.curSwpierIndex1 = i;
    },
    select(item) {
      this.input2 = item;
    },
    search(param) {
      console.log(param);
      if (typeof param == "string") {
        this.$router.push({
          path: "/search",
          query: {
            type: param,
          },
        });
        return;
      }
      if (!this.input2) {
        this.$router.push({
          path: "/search",
        });
      } else {
        this.$router.push({
          path: "/search",
          query: {
            searchKey: this.input2,
          },
        });
      }
    },
    setOption1() {
      var that = this;
      this.swiperTop = {
        autoplay: true,
        // loop: true,

        spaceBetween: 40,
        // centeredSlides: true,
        slidesPerView: 3,
        on: {
          click: function (e) {
            // console.log("你点了Swiper");
            // alert("你点了Swiper");
            // alert("你点了Swiper"+this.activeIndex);
            // clickedIndex
            // this.snapIndex=this.clickedIndex
            // this.activeIndex=this.clickedIndex
            // this.slideTo(this.clickedIndex , 300, false);
            // that.eell.slideTo(this.clickedIndex, 300, false);
            // console.log(this)

            that.$router.push({
              path: "/workDetails",
              query: {
                id: that.listTop[this.clickedIndex].id,
                workId: that.listTop[this.clickedIndex].workId,
              },
            });
          },

          slideChange: function () {
            //  console.log("改变了，activeIndex为" + this.activeIndex);
            if (this.activeIndex == 0) {
              that.isShow1.pre = false;
              that.isShow1.next = true;
            } else if (this.activeIndex == that.listTopLength - 3) {
              that.isShow1.next = false;
              that.isShow1.pre = true;
            } else {
              that.isShow1.pre = true;
              that.isShow1.next = true;
            }
          },
        },
      };
    },
    setOption2() {
      var that = this;
      this.swiperBm = {
        autoplay: true,
        spaceBetween: 40,
        // centeredSlides: true,
        slidesPerView: 3,
        on: {
          click: function (e) {
            that.$router.push({
              path: "/workDetails",
              query: {
                id: that.listBm[this.clickedIndex].id,
                workId: that.listBm[this.clickedIndex].workId,
              },
            });

            // console.log("你点了Swiper");
          },
          slideChange: function () {
            //  console.log("改变了，activeIndex为" + this.activeIndex);
            if (this.activeIndex == 0) {
              that.isShow2.pre = false;
              that.isShow2.next = true;
            } else if (this.activeIndex == that.listBmLength - 3) {
              that.isShow2.next = false;
              that.isShow2.pre = true;
            } else {
              that.isShow2.pre = true;
              that.isShow2.next = true;
            }
          },
        },
      };
    },
  },
};
</script>

<style lang='less' scoped>
.look-more {
  margin: 30px 0;
  height: 48px;
  // max-width: 90%;
  width: 100%;
  font-size: 24px;
  font-weight: 500;
  color: #333333;
  line-height: 48px;
  position: relative;
  cursor: pointer;

  &.right {
    text-align: right;
  }

  &.left {
    text-align: left;
  }
}

.recommand-wrapper-swiper:hover button {
  opacity: 1 !important;

  &.carousel__arrow__left {
    left: -28px !important;
  }

  &.carousel__arrow__right {
    right: -28px !important;
  }
}

.recommand-wrapper-swiper button {
  transition: all 0.5s;
  opacity: 0 !important;
}

body {
  border: 0;
}

.mask {
  display: none;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0%;
  // background-color: rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

img,
.item-txt-lr,
.mask {
  transition: all 0.5s;
}

@keyframes show {
  0% {
    height: 0%;
  }

  100% {
    height: 100%;
  }
}

@keyframes close {
  0% {
    height: 100;
  }

  100% {
    height: 0%;
  }
}

.img-animate:hover img {
  transform: scale(1.05);
}

.img-animate:hover .mask {
  // animation: show 300ms;
  // animation-fill-mode: forwards;
  height: 100%;
}

.img-animate:hover + .item-txt-lr {
  opacity: 1;
}

.img-animate + .item-txt-lr {
  opacity: 0;
}

.img-animate:hover .item-txt-lr {
  opacity: 1;
}

.img-animate .item-txt-lr {
  opacity: 0;
}

.item-txt-lr {
  position: absolute;
  bottom: 30px;
  left: 30px;
  right: 30px;
  height: 40px;
  font-size: 28px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 40px;
  // letter-spacing: 30px;F
  // -webkit-text-stroke: 1px #FFFFFF;
  // text-stroke: 1px #FFFFFF;
}

.img-wrapper {
  position: relative;
  height: 100%;
  overflow: hidden;
  border-radius: 16px 16px 16px 16px;
}

.img-wrapper.swiper-img {
  position: relative;
  height: 100%;
  overflow: hidden;
  border-radius: 16px 16px 16px 16px;
}

.flex-bt {
  display: flex;
  justify-content: space-between;
}

.flex-bt-y {
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}

.swiper-slide-item {
  border-radius: 16px;
  overflow: hidden;
}

.pointer {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/* 隐藏鼠标点击这些元素时出现的光标 */
// div {
//     caret-color: transparent;
// }
.recommand-wrapper-swiper .swipernn {
  height: 240px;
  width: 980px;
}

.clearfix:after {
  content: "020";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  /* 触发 hasLayout */
  zoom: 1;
}

.disNo {
  display: none;
}

/deep/ .el-carousel--horizontal {
  overflow-x: auto;
}

/deep/ .el-carousel__container {
  position: relative;

  .el-carousel__arrow {
    display: none !important;
    width: 57px;
    height: 57px;
    background: #ffffff;
    box-shadow: 0px 0px 15px 1px rgba(137, 100, 99, 0.36);
    opacity: 1;

    &.el-carousel__arrow--right {
      right: 0;
    }

    i {
      font-weight: 700 !important;
      color: #e29898 !important;
    }
  }

  .el-carousel__item {
    overflow: hidden;
  }
}

// background: #FFFFFF;

/deep/ .el-input__inner {
  font-size: 28px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  height: 64px;
  line-height: 64px;
}

/deep/ .el-input-group__append {
  width: 94px;
  text-align: center;

  .el-icon-search {
    font-weight: 600;
    font-size: 32px;
  }
}

/deep/ .active2 .el-input__inner {
  font-size: 28px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #333 !important;
  height: 64px;
  line-height: 64px;
}

.bqv2-index {
  position: relative;
  overflow: hidden;
  color: #333333;
  min-width: 1440px;
}

.wrapper {
  width: 1200px;
  margin: 0 auto;
}

.content-wrapper {
  padding-top: 43px;

  .search-wrapper {
    width: 846px;
    height: 46px;
    margin: 0 auto;

    .search-wrapper-input {
      position: relative;
      outline: 1px;
      outline-color: #333333;
    }

    .search-tag {
      //   width: 242px;
      height: 25px;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;
      line-height: 1;
    }
  }

  .recommand-wrapper {
    .carousel-img {
      width: 300px;
      height: 240px;
      margin-right: 40px;
      border-radius: 16px;

      &:last-child {
        margin-right: 0px;
      }
    }

    .recommand-wrapper-img {
      width: 34px;
      height: 272px;
      margin-right: 7px;
      vertical-align: middle;
      float: left;
    }

    .recommand-wrapper-txt {
      padding-left: 7px;
      float: left;
      writing-mode: vertical-lr;
      width: 34px;
      height: 192px;
      font-size: 34px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      // line-height: 40px;
      letter-spacing: 13px;
      line-height: 1;
      position: relative;

      &::before {
        content: "";
        display: block;
        position: absolute;
        width: 2px;
        height: 181px;
        //  color: #333333;
        left: -5px;
        background-color: #333333;
      }
    }

    .recommand-wrapper-txt2 {
      text-align: center;
      // padding-left: 7px;
      float: left;
      padding-left: 17px;
      word-wrap: break-word;
      width: 34px;
      height: 272px;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      // line-height: 40px;
      letter-spacing: 17px;
      line-height: 1.05;
    }

    .recommand-wrapper-like {
      float: left;
      width: 99px;
      height: 28px;
      font-size: 20px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #e29898;
      line-height: 28px;
      margin-left: 14px;
      padding-top: 215px;
    }

    .recommand-wrapper-swiper {
      position: relative;
      float: right;
      width: 980px;
      height: 240px;

      // border: 1px solid red;
      .carousel__arrow {
        border: none;
        outline: 0;
        padding: 0;
        margin: 0;
        height: 57px;
        width: 57px;
        cursor: pointer;
        -webkit-transition: 0.3s;
        transition: 0.3s;
        border-radius: 50%;
        background: #ffffff;
        box-shadow: 0px 0px 15px 1px rgba(137, 100, 99, 0.36);
        opacity: 1;
        position: absolute;
        top: 50%;
        z-index: 10;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        text-align: center;
        font-size: 12px;

        &.carousel__arrow__left {
          left: -56px;
        }

        &.carousel__arrow__right {
          right: -56px;
        }

        .icon-arrow {
          font-family: element-icons !important;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          font-variant: normal;
          text-transform: none;
          line-height: 1;
          vertical-align: baseline;
          display: inline-block;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          font-weight: 700 !important;
          color: #e29898 !important;
        }
      }
    }
  }

  .contentwrapper {
    .contentwrapper2,
    .contentwrapper1 {
      width: 100%;
      // min-width: 1920px;
      // height: 1741px;
      // background: #f2efec;
      // border-radius: 320px 0px 0px 0px;
      opacity: 1;

      .odd-item {
        background: #f2efec;
        border-radius: 240px 0px 0px 0px;

        .item-txt {
          float: left;
        }

        .item-img {
          height: 698px;

          .item-img-left {
            position: relative;
            float: left;
            height: 100%;

            img {
              width: 523px;
              height: 100%;
              border-radius: 16px 16px 16px 16px;
              position: relative;
            }

            .item-txt-lr {
              position: absolute;
              left: 30px;
              bottom: 30px;
              // height: 40px;
              font-size: 28px;
              font-weight: 600;
              color: #ffffff;
              line-height: 40px;
              // letter-spacing: 30px;
              // -webkit-text-stroke: 1px #FFFFFF;
              // text-stroke: 1px #FFFFFF;
            }
          }

          .item-img-right {
            float: right;

            img:first-child {
              // margin-bottom: 64px;
            }

            img {
              width: 641px;
              height: 317px;
              border-radius: 16px 16px 16px 16px;
            }
          }
        }
      }

      .even-item {
        border-radius: 0px 240px 0px 0px;
        background: #ffffff;

        .item-txt {
          float: right;
        }

        .item-img {
          height: 698px;

          .item-img-left {
            float: left;

            img:first-child {
              // margin-bottom: 64px;
            }

            img {
              width: 523px;
              height: 317px;
              border-radius: 16px 16px 16px 16px;
            }
          }

          .item-img-right {
            position: relative;
            height: 100%;
            float: right;

            img {
              width: 523px;
              height: 698px;
              border-radius: 16px 16px 16px 16px;
              position: relative;
            }

            .item-txt-lr {
              position: absolute;
              left: 30px;
              bottom: 30px;
              // height: 40px;
              font-size: 28px;
              font-weight: 600;
              color: #ffffff;
              line-height: 40px;
              // letter-spacing: 30px;
              // -webkit-text-stroke: 1px #FFFFFF;
              // text-stroke: 1px #FFFFFF;
            }
          }
        }
      }

      .item-txt {
        margin: 30px 0;
        height: 48px;
        max-width: 90%;
        width: auto;
        font-size: 34px;
        font-weight: 500;
        color: #333333;
        line-height: 48px;
        position: relative;

        img {
          position: absolute;
          right: -27px;
          top: -7px;
          width: 70px;
          height: 64px;
          vertical-align: middle;
        }
      }
    }

    .contentwrapper1 {
      .bgc {
        // height: 1199px !important;
        // background: url(https://img2.baidu.com/it/u=3635204433,939208923&fm=253&fmt=auto&app=138&f=JPEG?w=375&h=500);
        // background-repeat: no-repeat;
        // background-size: cover;
        // -webkit-background-size: cover;
        // -o-background-size: cover;
        // background-position: center;
      }
    }
  }
}

.contentwrapper1 {
  .contentwrapper-item {
    &.odd-item {
      position: relative;
      background: #fff !important;
      border-radius: 0px 0px 0px 0px !important;

      .contentwrapper-item2 {
        background: #f2efec;
        border-radius: 240px 0px 0px 0px;
        height: 100%;
      }
    }

    &.even-item {
      position: relative;
      background: #f2efec !important;
      border-radius: 0px 0px 0px 0px !important;

      .contentwrapper-item2 {
        background: #fff;
        border-radius: 0px 240px 0px 0px;
        height: 100%;
      }
    }

    &.bgc {
      min-width: 1920px;
      position: relative;
      width: 100%;

      .contentwrapper-item2 {
        background: url(https://img0.baidu.com/it/u=3428234490,337022739&fm=253&fmt=auto&app=138&f=JPEG?w=650&h=325);
        background-repeat: no-repeat;
        background-size: cover;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-position: top center;
        // border-radius: 0px 320px 0px 0px;
        // overflow: hidden;
        width: 100%;
        padding-bottom: 31.35%;
      }

      .bg-title {
        position: absolute;
        top: 27%;
        width: 400px;
        // height: 100px;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      background-color: #f2efec;
    }

    &.change {
      background: transparent !important;

      .contentwrapper-item2 {
        border-radius: 0px 240px 0px 0px;
        background-color: #f2efec;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/V2/index.vue